import { useAllSystemInfo } from "./AllSystemInfo.hooks.ts";
import { EntityType } from "@common/Common.types.ts";
import React from "react";
import { Box } from "@mui/material";
import { DotLegalFullScreenSpinner } from "@dotlegal/dotlegal-ui-components";
import AllEntityInfo from "@common/components/overviewStepSection/AllEntityInfo.tsx";
import { topPaperMinHeight } from "../SystemOverview.tsx";
import useSystemDisplayFields from "../../systems/systemDisplayFields/SystemDisplayFields.hooks.ts";
import { getFilterIdByEnum } from "../../systems/systemDisplayFields/SystemDisplayFields.types.ts";
import { FieldValue } from "@common/components/overviewStepSection/OverviewStepSection.types.ts";
import { SystemFieldAndGrouping } from "@common/components/filterPopover/FilterPopover.types.ts";
import { useUrlProvider } from "../../../useUrlProvider.ts";

export interface AllSystemInfoProps {
    systemId: string;
}

function AllSystemInfo(props: AllSystemInfoProps) {
    const { isLoading, data } = useAllSystemInfo(props);
    const { getTableFieldsDictionary, filterIdToEnumMap, isLoading: isFieldsLoading } = useSystemDisplayFields();
    const { getSystemEditUrl } = useUrlProvider();

    if (isFieldsLoading)
        return (
            <Box sx={{ height: topPaperMinHeight }}>
                <DotLegalFullScreenSpinner />
            </Box>
        );

    const dictionary = getTableFieldsDictionary();

    function getFieldDisplayName(fieldValue: FieldValue, dict: Record<string, SystemFieldAndGrouping>): string {
        if (fieldValue.isCustomField && fieldValue.customFieldId) {
            return dict[fieldValue.customFieldId]?.translation || fieldValue.customFieldId;
        }

        if (fieldValue.column !== undefined) {
            const filterId = getFilterIdByEnum(fieldValue.column, filterIdToEnumMap);
            return filterId ? dict[filterId]?.translation || filterId : "";
        }

        return "";
    }

    return (
        <AllEntityInfo
            entityId={props.systemId}
            entityType={EntityType.System}
            steps={data?.steps}
            isLoading={isLoading}
            getFieldDisplayName={getFieldDisplayName}
            dictionary={dictionary}
            minHeight={topPaperMinHeight}
            getNavigateUrl={(entityId, stepOrder) => getSystemEditUrl(entityId, stepOrder)}
        />
    );
}

export default AllSystemInfo;
